<template>
  <a-tabs v-model="activeTabId" type="card" class="phone-preview__tabs">
    <a-tab-pane v-for="tab in tabs" :key="tab.id" :tab="tab.name">
      <template>
        <component :is="tab.component" :settings="currentForm" />
      </template>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
import PhoneScreenMain1 from './screens/PhoneScreenMain1.vue'
import PhoneScreenMain2 from './screens/PhoneScreenMain2.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      activeTabId: 'main1',
      tabs: [
        {
          id: 'main1',
          name: 'Events 1',
          component: PhoneScreenMain1,
        },
        {
          id: 'main2',
          name: 'Events 2',
          component: PhoneScreenMain2,
        },
      ],
    }
  },
  computed: {
    ...mapState({
      langs: (state) => state.langs.langData,
    }),
    ...mapGetters('settings', [
      'selectedLanguage',
      'form',
      'currentForm',
    ]),
  },
}
</script>
<style scoped lang="scss">
.phone-preview__tabs {
  height: 100%;
  overflow: initial;

  ::v-deep .ant-tabs-bar {
    margin-bottom: 0;
  }

  ::v-deep .ant-tabs-tab {
    margin-right: 2px !important;
  }

  ::v-deep .ant-tabs-content {
    padding: 16px;
    border: solid #e4e9f0;
    border-width: 0 1px 1px 1px;
    border-radius: 0 4px 4px 4px;
    background: #fff;
    height: 96%;

    .ant-tabs-tabpane[aria-hidden="false"] {
      height: 100%;
    }
  }

  ::v-deep .phone {
    position: sticky;
    top: 180px;
    border-radius: 25px;
    overflow: hidden;
  }
}
</style>
